import React, { useEffect } from "react";
import { useDispatch, useStore } from "../../store";
import { Link } from "react-router-dom";
import AlertList from "./AlertList";
import {
  Spinner,
  Anchor,
  Button,
  Type,
  useMediaQuery,
} from "discover.medical.react-component-library";
import { fetchAlerts } from "../../store/actions/home";
import useCTA, { CTA_TRIGGER_ACTION } from "../../util/useCTA";
import { useEventBus, EVENT_BUS_EVENTS } from "../../util/useEventBus";

export const Alerts = ({ className }) => {
  const eventBus = useEventBus();
  const dispatch = useDispatch();
  const { alerts, isFetchingAlerts } = useStore().home || {};
  const { all, followed } = alerts || {};
  const { hasCTA } = useCTA();

  const isSmallMedia = useMediaQuery("min", "sm");
  const buttonSize = isSmallMedia ? "md" : "sm";

  useEffect(() => {
    const handler = () => fetchAlerts(dispatch);
    eventBus.on(EVENT_BUS_EVENTS.TOPIC_UNSUBSCRIBED, handler);
    eventBus.on(EVENT_BUS_EVENTS.SPECIALTY_UNSUBSCRIBED, handler);
    return () => {
      eventBus.detach(EVENT_BUS_EVENTS.TOPIC_UNSUBSCRIBED, handler);
      eventBus.detach(EVENT_BUS_EVENTS.SPECIALTY_UNSUBSCRIBED, handler);
    };
  }, [eventBus, dispatch]);

  if (isFetchingAlerts) {
    return (
      <section className={className}>
        <Spinner size="lg" />
      </section>
    );
  }

  if (!all || all.error) {
    return null;
  }

  const openFollowedContentModal = (e) => {
    if (hasCTA(e, CTA_TRIGGER_ACTION.OPEN_FOLLOW_CONTENT_MODAL)) {
      return;
    }
    eventBus.emit(EVENT_BUS_EVENTS.FOLLOWED_CONTENT_MODAL_OPENED);
  };

  const hasFollowedAlerts = !!(followed && !followed.error);

  return (
    <section className={className}>
      <Type element="h1" color="gray800" fontFamily="secondary">
        Recent Alerts
      </Type>
      <Type element="p" marginBottom="lg">
        <Anchor to="/browse/specialties" as={Link}>
          <Type element="span" fontWeight="bold" color="anchor">
            Follow your specialty
          </Type>
        </Anchor>
        &nbsp;and individual topics to personalize alerts.&nbsp;
        {hasFollowedAlerts && (
          <>
            <Button kind="anchor" onClick={openFollowedContentModal}>
              <Type
                element="span"
                display="inline"
                fontWeight="bold"
                color="anchor"
              >
                Manage
              </Type>
            </Button>{" "}
            followed content.
          </>
        )}
      </Type>
      <AlertList data-testid="alert-list" all={all} followed={followed} />
      <Button
        to="/alerts"
        as={Link}
        variant="primary"
        fullWidth={!isSmallMedia}
        kind="outlined"
        size={buttonSize}
      >
        View All Alerts
      </Button>
    </section>
  );
};

export default Alerts;
